/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './dental-mouth-item.reducer';

export const DentalMouthItemDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const dentalMouthItemEntity = useAppSelector(state => state.dentalMouthItem.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="dentalMouthItemDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.dentalMouthItem.detail.title">DentalMouthItem</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.dentalMouthItem.id">Id</Translate>
            </span>
          </dt>
          <dd>{dentalMouthItemEntity.id}</dd>
          <dt>
            <span id="available">
              <Translate contentKey="tinyMedicRestApp.dentalMouthItem.available">Available</Translate>
            </span>
          </dt>
          <dd>{dentalMouthItemEntity.available ? 'true' : 'false'}</dd>
          <dt>
            <span id="implant">
              <Translate contentKey="tinyMedicRestApp.dentalMouthItem.implant">Implant</Translate>
            </span>
          </dt>
          <dd>{dentalMouthItemEntity.implant ? 'true' : 'false'}</dd>
          <dt>
            <span id="mobility">
              <Translate contentKey="tinyMedicRestApp.dentalMouthItem.mobility">Mobility</Translate>
            </span>
          </dt>
          <dd>{dentalMouthItemEntity.mobility}</dd>
          <dt>
            <span id="fork1">
              <Translate contentKey="tinyMedicRestApp.dentalMouthItem.fork1">Fork 1</Translate>
            </span>
          </dt>
          <dd>{dentalMouthItemEntity.fork1}</dd>
          <dt>
            <span id="bleeding1">
              <Translate contentKey="tinyMedicRestApp.dentalMouthItem.bleeding1">Bleeding 1</Translate>
            </span>
          </dt>
          <dd>{dentalMouthItemEntity.bleeding1}</dd>
          <dt>
            <span id="bleeding2">
              <Translate contentKey="tinyMedicRestApp.dentalMouthItem.bleeding2">Bleeding 2</Translate>
            </span>
          </dt>
          <dd>{dentalMouthItemEntity.bleeding2}</dd>
          <dt>
            <span id="bleeding3">
              <Translate contentKey="tinyMedicRestApp.dentalMouthItem.bleeding3">Bleeding 3</Translate>
            </span>
          </dt>
          <dd>{dentalMouthItemEntity.bleeding3}</dd>
          <dt>
            <span id="bleeding4">
              <Translate contentKey="tinyMedicRestApp.dentalMouthItem.bleeding4">Bleeding 4</Translate>
            </span>
          </dt>
          <dd>{dentalMouthItemEntity.bleeding4}</dd>
          <dt>
            <span id="bleeding5">
              <Translate contentKey="tinyMedicRestApp.dentalMouthItem.bleeding5">Bleeding 5</Translate>
            </span>
          </dt>
          <dd>{dentalMouthItemEntity.bleeding5}</dd>
          <dt>
            <span id="bleeding6">
              <Translate contentKey="tinyMedicRestApp.dentalMouthItem.bleeding6">Bleeding 6</Translate>
            </span>
          </dt>
          <dd>{dentalMouthItemEntity.bleeding6}</dd>
          <dt>
            <span id="plaque1">
              <Translate contentKey="tinyMedicRestApp.dentalMouthItem.plaque1">Plaque 1</Translate>
            </span>
          </dt>
          <dd>{dentalMouthItemEntity.plaque1}</dd>
          <dt>
            <span id="plaque2">
              <Translate contentKey="tinyMedicRestApp.dentalMouthItem.plaque2">Plaque 2</Translate>
            </span>
          </dt>
          <dd>{dentalMouthItemEntity.plaque2}</dd>
          <dt>
            <span id="plaque3">
              <Translate contentKey="tinyMedicRestApp.dentalMouthItem.plaque3">Plaque 3</Translate>
            </span>
          </dt>
          <dd>{dentalMouthItemEntity.plaque3}</dd>
          <dt>
            <span id="plaque4">
              <Translate contentKey="tinyMedicRestApp.dentalMouthItem.plaque4">Plaque 4</Translate>
            </span>
          </dt>
          <dd>{dentalMouthItemEntity.plaque4}</dd>
          <dt>
            <span id="plaque5">
              <Translate contentKey="tinyMedicRestApp.dentalMouthItem.plaque5">Plaque 5</Translate>
            </span>
          </dt>
          <dd>{dentalMouthItemEntity.plaque5}</dd>
          <dt>
            <span id="plaque6">
              <Translate contentKey="tinyMedicRestApp.dentalMouthItem.plaque6">Plaque 6</Translate>
            </span>
          </dt>
          <dd>{dentalMouthItemEntity.plaque6}</dd>
          <dt>
            <span id="gum">
              <Translate contentKey="tinyMedicRestApp.dentalMouthItem.gum">Gum</Translate>
            </span>
          </dt>
          <dd>{dentalMouthItemEntity.gum}</dd>
          <dt>
            <span id="margin1">
              <Translate contentKey="tinyMedicRestApp.dentalMouthItem.margin1">Margin 1</Translate>
            </span>
          </dt>
          <dd>{dentalMouthItemEntity.margin1}</dd>
          <dt>
            <span id="margin2">
              <Translate contentKey="tinyMedicRestApp.dentalMouthItem.margin2">Margin 2</Translate>
            </span>
          </dt>
          <dd>{dentalMouthItemEntity.margin2}</dd>
          <dt>
            <span id="margin3">
              <Translate contentKey="tinyMedicRestApp.dentalMouthItem.margin3">Margin 3</Translate>
            </span>
          </dt>
          <dd>{dentalMouthItemEntity.margin3}</dd>
          <dt>
            <span id="margin4">
              <Translate contentKey="tinyMedicRestApp.dentalMouthItem.margin4">Margin 4</Translate>
            </span>
          </dt>
          <dd>{dentalMouthItemEntity.margin4}</dd>
          <dt>
            <span id="margin5">
              <Translate contentKey="tinyMedicRestApp.dentalMouthItem.margin5">Margin 5</Translate>
            </span>
          </dt>
          <dd>{dentalMouthItemEntity.margin5}</dd>
          <dt>
            <span id="margin6">
              <Translate contentKey="tinyMedicRestApp.dentalMouthItem.margin6">Margin 6</Translate>
            </span>
          </dt>
          <dd>{dentalMouthItemEntity.margin6}</dd>
          <dt>
            <span id="depth1">
              <Translate contentKey="tinyMedicRestApp.dentalMouthItem.depth1">Depth 1</Translate>
            </span>
          </dt>
          <dd>{dentalMouthItemEntity.depth1}</dd>
          <dt>
            <span id="depth2">
              <Translate contentKey="tinyMedicRestApp.dentalMouthItem.depth2">Depth 2</Translate>
            </span>
          </dt>
          <dd>{dentalMouthItemEntity.depth2}</dd>
          <dt>
            <span id="depth3">
              <Translate contentKey="tinyMedicRestApp.dentalMouthItem.depth3">Depth 3</Translate>
            </span>
          </dt>
          <dd>{dentalMouthItemEntity.depth3}</dd>
          <dt>
            <span id="depth4">
              <Translate contentKey="tinyMedicRestApp.dentalMouthItem.depth4">Depth 4</Translate>
            </span>
          </dt>
          <dd>{dentalMouthItemEntity.depth4}</dd>
          <dt>
            <span id="depth5">
              <Translate contentKey="tinyMedicRestApp.dentalMouthItem.depth5">Depth 5</Translate>
            </span>
          </dt>
          <dd>{dentalMouthItemEntity.depth5}</dd>
          <dt>
            <span id="depth6">
              <Translate contentKey="tinyMedicRestApp.dentalMouthItem.depth6">Depth 6</Translate>
            </span>
          </dt>
          <dd>{dentalMouthItemEntity.depth6}</dd>
          <dt>
            <span id="fork2">
              <Translate contentKey="tinyMedicRestApp.dentalMouthItem.fork2">Fork 2</Translate>
            </span>
          </dt>
          <dd>{dentalMouthItemEntity.fork2}</dd>
          <dt>
            <span id="fork3">
              <Translate contentKey="tinyMedicRestApp.dentalMouthItem.fork3">Fork 3</Translate>
            </span>
          </dt>
          <dd>{dentalMouthItemEntity.fork3}</dd>
          <dt>
            <span id="notes">
              <Translate contentKey="tinyMedicRestApp.dentalMouthItem.notes">Notes</Translate>
            </span>
          </dt>
          <dd>{dentalMouthItemEntity.notes}</dd>
          <dt>
            <span id="treatments">
              <Translate contentKey="tinyMedicRestApp.dentalMouthItem.treatments">Treatments</Translate>
            </span>
          </dt>
          <dd>{dentalMouthItemEntity.treatments}</dd>
          <dt>
            <span id="examinedDate">
              <Translate contentKey="tinyMedicRestApp.dentalMouthItem.examinedDate">Examined Date</Translate>
            </span>
          </dt>
          <dd>{dentalMouthItemEntity.examinedDate}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.dentalMouthItem.active">Active</Translate>
            </span>
          </dt>
          <dd>{dentalMouthItemEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.dentalMouthItem.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{dentalMouthItemEntity.cursor}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.dentalMouthItem.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{dentalMouthItemEntity.lastupdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.dentalMouthItem.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{dentalMouthItemEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.dentalMouthItem.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{dentalMouthItemEntity.timestampentry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.dentalMouthItem.tooth">Tooth</Translate>
          </dt>
          <dd>{dentalMouthItemEntity.tooth ? dentalMouthItemEntity.tooth.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.dentalMouthItem.patient">Patient</Translate>
          </dt>
          <dd>{dentalMouthItemEntity.patient ? dentalMouthItemEntity.patient.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.dentalMouthItem.medicalHistory">Medical History</Translate>
          </dt>
          <dd>{dentalMouthItemEntity.medicalHistory ? dentalMouthItemEntity.medicalHistory.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.dentalMouthItem.exam">Exam</Translate>
          </dt>
          <dd>{dentalMouthItemEntity.exam ? dentalMouthItemEntity.exam.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/dental-mouth-item" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/dental-mouth-item/${dentalMouthItemEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default DentalMouthItemDetail;
